<script>
export default {
  name: 'CodeEnter',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: Object
  },
  data() {
    return {
      visible: false,
      code: null,
      info: {}
    };
  },
  watch: {
    value: {
      handler() {
        this.visible = this.value;
      },
      immediate: true
    }
  },
  created() {
    this.info = this.data || {};
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('input', false);
    },
    inputCode(code) {
      this.code = code;
    },
    submit() {
      this.$emit('submit', {
        code: this.code,
        close: () => {
          this.close();
        }
      });
    }
  },
  render() {
    const props = {
      props: {
        value: this.visible,
        'close-on-click-overlay': false
      }
    };
    return (
      // <div class="avator-wrap">{this.info.appImage ? <van-image round width="90" height="90" src={this.info.appImage} /> : null}</div>
      // <div class="title">{this.info.appName}</div>
      <van-action-sheet {...props}>
        <div class="content">
          <van-field class="item-input" border={false} {...{ on: { input: this.inputCode } }} placeholder="请输入直播码进入直播间" />
          <van-button onclick={this.submit} class="item-button" type="info">
            确认
          </van-button>
        </div>
      </van-action-sheet>
    );
  }
};
</script>
<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.content {
  padding: 10px 40px 38px;
  .avator-wrap {
    text-align: center;
  }
  .title {
    text-align: center;
    line-height: 36px;
    width: 100%;
    margin-top: 8px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(32, 34, 36, 1);
  }
  .item-input {
    margin-top: 36px;
    width: 100%;
    height: 42px;
    border-radius: 21px;
    border: 0.5px solid rgba(204, 204, 204, 0.5);
  }
  .item-button {
    margin-top: 36px;
    width: 100%;
    height: 39px;
    border-radius: 19px;
    background: linear-gradient(270deg, rgba(0, 198, 252, 1) 0%, rgba(0, 148, 247, 1) 100%);
    border: 0;
  }
}
</style>
